import Glalie from './Glalie';
import image from './preview.png';

export const Image = image;
export default Glalie;
